import React from "react";

import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useState } from "react";
import {
  setTheQueryQuestionsEditActions,
  setTheQueryQuestionsRetrieveActions,
  setTheQueryQuestionsCreateActions,
} from "../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const QueryActions = (props) => {
  const { setShow, show, currentPage, EditID , search} = props;

  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const Headers = {
    name: "",
    description: "",
  };
  const [Data, setDatas] = useState(Headers);
  const [queryError, setqueryErr] = useState("");
  const [descriptionsErr, setDestionErr] = useState("");
  useEffect(() => {
    if (EditID != undefined && EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(setTheQueryQuestionsRetrieveActions(payload));
    }
  }, []);

  useEffect(() => {
    if (
      EditID != undefined &&
      EditID != "" &&
      state.QueryQuestionsRetrieve.QueryQuestionRetrieve.id
    ) {
      setDatas({
        name: state.QueryQuestionsRetrieve.QueryQuestionRetrieve.name,
        description:
          state.QueryQuestionsRetrieve.QueryQuestionRetrieve.description,
      });
    }
  }, [state.QueryQuestionsRetrieve.QueryQuestionRetrieve , EditID]);



  const HandleChanges = (e) => {
    setDatas((pre) => {
      return {
        ...pre,            
        [e.target.name]: e.target.value,
      };
    });
  };

  const HandleSubmits = (e) => {
    e.preventDefault();
  };

  const HandleSubmit = (e) => {
    var a = 0;

    if (EditID == undefined ||  EditID == "") {
      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Category is required");
        a = 1;
      }

      if (a == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          search:search
        };

        dispatch(setTheQueryQuestionsCreateActions(payload, setShow(false)));
      }
    } 
    
    
   else if (EditID != undefined || EditID != "") {
      
      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Category is required");
        a = 1;
      }

      if (a == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          EditID: EditID,
          search:search
        };

        dispatch(setTheQueryQuestionsEditActions(payload, setShow(false)));
      }
    }
  };

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "30%" }}>
            <div className="asds">
              <div class="ModalHeader">
                {EditID != undefined && EditID != "" ? (
                  <span className="UserCreate"> Ticket Category </span>
                ) : (
                  <span className="UserCreate"> Ticket Category </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <form class="row g-3 form-fields-wrapper" onClick={HandleSubmits}>
                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                   Category
                   <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.name}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                    }}
                    required
                    name="name"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{queryError}</p>
                </div>

                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Description                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.description}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                    }}
                    required
                    name="description"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {descriptionsErr}
                  </p>
                </div>
              </form>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
                    //   HandleEdits(e);
                  }}
                >
                  Submit
                </button>
                <button
                  class="btn CancelBtn"
                  //  onClick={handleClose}
                  onClick={(e) => setShow(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QueryActions;
